<script lang="ts">
    import type {CssSpacing, FlexAlignItems, FlexJustifyContent, FlexWrap} from 'shared/layouts/flex/types';
    import type {CssSize} from 'shared/ui-widgets/types';

    export let gap: CssSpacing | CssSize = 0;
    export let alignItems: FlexAlignItems = 'initial';
    export let justifyContent: FlexJustifyContent = 'initial';
    export let flexWrap: FlexWrap = 'initial';
    export let flexGrow: number | string = 0;
    export let flexShrink: number | string = 1;
    export let flexBasis: CssSize = 'auto';
    export let additionalClasses = '';
    export let fillSize = false;
</script>

<div class="kp-flex-row {additionalClasses}"
     style:gap={`var(--portaro-spacing-${gap})`}
     style:display="flex"
     style:flex-direction="row"
     style:align-items={alignItems}
     style:justify-content={justifyContent}
     style:flex-wrap={flexWrap}
     style:flex-grow={fillSize ? '1' : flexGrow}
     style:flex-shrink={fillSize ? '1' : flexShrink}
     style:flex-basis={fillSize ? '0' : flexBasis}>

    <slot/>
</div>